<page-heading
  [title]="'report.conversationAnalytics.title' | translate"
  [description]="'report.conversationAnalytics.description' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row g-2 d-flex justify-content-end">
            <div class="col-xs-12 col-lg-3 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.conversationAnalytics.startDate' | translate"
                  formControlName="start"
                />
                <input
                  matEndDate
                  [placeholder]="'report.conversationAnalytics.endDate' | translate"
                  formControlName="end"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    (selectionChange)="onPeriodChange($event)"
                    [placeholder]="'report.conversationAnalytics.selectPlaceholder' | translate"
                  >
                    <mat-option value="30">{{ 'report.conversationAnalytics.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'report.conversationAnalytics.last60Days' | translate }}</mat-option>
                    <mat-option value="90">{{ 'report.conversationAnalytics.last90Days' | translate }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-2 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterChannel"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel | translate }}</span>
              </button>
              <mat-menu #filterChannel="matMenu">
                <button mat-menu-item (click)="searchByChannel(null)">
                  {{ 'report.conversationAnalytics.allChannels' | translate }}
                </button>
                @for (channel of listChannel; track $index) {
                <button mat-menu-item (click)="searchByChannel(channel)">
                  {{ channel.name }}
                </button>
                }
              </mat-menu>
            </div>
          </div>
        </form>
      </div>
    </div>
    @if (loadingContent) {<content-loading-card />} @if (isDataAnalyticsExists
    && !loadingContent) {
    <div class="card-body mb-3">
      <div class="alert alert-info" role="alert">
        <i class="ri-information-line me-1 align-middle font-16"></i>
        <span>
          {{ 'report.conversationAnalytics.insightsApproximateNotice' | translate }}
        </span>
      </div>
      <div class="d-flex flex-wrap gap-2">
        <div class="flex-fill">
          <app-analytics-card
            [title]="'report.conversationAnalytics.allConversationsCardTitle' | translate"
            [total]="totalConversationsCount"
            [infoTooltip]="'report.conversationAnalytics.allConversationsCardTooltip' | translate"
            [items]="allConversations"
          ></app-analytics-card>
        </div>
        <div class="flex-fill">
          <app-analytics-card
            [title]="'report.conversationAnalytics.freeConversationsCardTitle' | translate"
            [total]="totalFreeConversationsCount"
            [infoTooltip]="'report.conversationAnalytics.freeConversationsCardTooltip' | translate"
            [items]="conversationFree"
          ></app-analytics-card>
        </div>
        <div class="flex-fill">
          <app-analytics-card
            [title]="'report.conversationAnalytics.paidConversationsCardTitle' | translate"
            [total]="totalPaidConversationsCount"
            [infoTooltip]="'report.conversationAnalytics.paidConversationsCardTooltip' | translate"
            [items]="conversationsPaid"
          ></app-analytics-card>
        </div>
        <div class="flex-fill">
          <app-analytics-card
            [title]="'report.conversationAnalytics.approximateChargesCardTitle' | translate"
            [total]="totalPaidConversationsCost"
            [infoTooltip]="'report.conversationAnalytics.approximateChargesCardTooltip' | translate"
            [items]="conversationsCost"
          ></app-analytics-card>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="chart-card">
          <h4 class="text-mutted">{{ 'report.conversationAnalytics.allConversationsChartTitle' | translate }}</h4>
          @if (allConversationsChart?.length) {
          <ngx-charts-line-chart
            [results]="allConversationsChart"
            [scheme]="colorScheme"
            [xAxis]="true"
            [yAxis]="true"
            [timeline]="false"
            [roundDomains]="true"
            [yScaleMin]="0"
            [autoResize]="true"
          ></ngx-charts-line-chart>
          } @else {
          <div class="d-flex align-items-center justify-content-center">
            <empty-records-component
              [message]="'report.conversationAnalytics.noConversationsFound' | translate"
              [icon]="'mdi mdi-alert-circle-outline'"
            />
          </div>
          }
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="chart-card">
          <h4 class="text-mutted">{{ 'report.conversationAnalytics.freeConversationsChartTitle' | translate }}</h4>
          @if (freeConversationsChart?.length) {
          <ngx-charts-line-chart
            [scheme]="colorScheme"
            [results]="freeConversationsChart"
            [xAxis]="true"
            [yAxis]="true"
            [timeline]="false"
            [roundDomains]="true"
            [yScaleMin]="0"
            [autoResize]="true"
          ></ngx-charts-line-chart>
          } @else {
          <div class="d-flex align-items-center justify-content-center">
            <empty-records-component
              [message]="'report.conversationAnalytics.noFreeConversationsFound' | translate"
              [icon]="'mdi mdi-alert-circle-outline'"
            />
          </div>
          }
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="chart-card">
          <h4 class="text-mutted">{{ 'report.conversationAnalytics.paidConversationsChartTitle' | translate }}</h4>
          @if (paidConversationsChart?.length) {
          <ngx-charts-line-chart
            [scheme]="colorScheme"
            [results]="paidConversationsChart"
            [xAxis]="true"
            [yAxis]="true"
            [timeline]="false"
            [roundDomains]="true"
            [yScaleMin]="0"
            [autoResize]="true"
          ></ngx-charts-line-chart>
          } @else {
          <div class="d-flex align-items-center justify-content-center">
            <empty-records-component
              [message]="'report.conversationAnalytics.noPaidConversationsFound' | translate"
              [icon]="'mdi mdi-alert-circle-outline'"
            />
          </div>
          }
        </div>
      </div>
    </div>

    } @else {
    <empty-records-component
      [message]="'report.conversationAnalytics.noAnalyticsDataFound' | translate"
      [icon]="'mdi mdi-alert-circle-outline'"
      [subMessage]="'report.conversationAnalytics.noAnalyticsDataSubMessage' | translate"
    />
    }
  </div>
</div>
